require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ./~/@xlts.dev/angular-cookies/index.js
// module id = 442
// module chunks = 0